/**
 * Tracks what CSS is currently loaded in the DOM.
 * Separate from window.__LAYOUT_CSS__ which loaders use to declare what's needed.
 */
let appliedCss: string[] = [];

/**
 * Call this after bootstrap() applies CSS so the tracker stays in sync.
 */
export function syncAppliedCss(cssUrls: string[]): void {
    appliedCss = cssUrls;
}

/**
 * Applies CSS URLs only if they differ from what is currently loaded in the DOM.
 * Prevents a needless remove+reapply flash when bootstrap() has already
 * applied the correct stylesheet for the initial URL.
 */
export function applyCssIfChanged(cssUrls: string[]): void {
    const unchanged =
        appliedCss.length === cssUrls.length && cssUrls.every((url, i) => url === appliedCss[i]);
    if (unchanged) return;

    appliedCss = cssUrls;
    window.__LAYOUT_CSS__ = cssUrls;
    window.__removeCss?.();
    window.__applyCss(cssUrls);
}
